export const GRAPHQL_GATEWAY_PATH = '/gateway/api/graphql';
export let VIEWED_EVENT = /*#__PURE__*/function (VIEWED_EVENT) {
  VIEWED_EVENT["VIEWED"] = "viewed";
  return VIEWED_EVENT;
}({});
export let WORKED_EVENT = /*#__PURE__*/function (WORKED_EVENT) {
  WORKED_EVENT["COMMENTED"] = "commented";
  WORKED_EVENT["CREATED"] = "created";
  WORKED_EVENT["EDITED"] = "edited";
  WORKED_EVENT["PUBLISHED"] = "published";
  WORKED_EVENT["UPDATED"] = "updated";
  return WORKED_EVENT;
}({});
export let ActivityObjectType = /*#__PURE__*/function (ActivityObjectType) {
  ActivityObjectType["BLOGPOST"] = "BLOGPOST";
  ActivityObjectType["COMMENT"] = "COMMENT";
  ActivityObjectType["ISSUE"] = "ISSUE";
  ActivityObjectType["PAGE"] = "PAGE";
  ActivityObjectType["PROJECT"] = "PROJECT";
  ActivityObjectType["SITE"] = "SITE";
  ActivityObjectType["SPACE"] = "SPACE";
  ActivityObjectType["TASK"] = "TASK";
  return ActivityObjectType;
}({});